<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else class="container">
      <div class="row">
        <div class="col-xs-6">
          <help-text>
            <h3>
              Create Person
            </h3>

            <p>
              Enter the details of the person.
            </p>
          </help-text>
        </div>

        <div class="col-xs-18">
          <form @submit.prevent="submit">
            <div class="panel panel-default">
              <div class="panel-body form-horizontal">
                <TextFormGroup
                    v-model="data.name"
                    name="name"
                    label="Name"
                    help-text="The name of the person."
                    :error="getError('name')"
                />

                <TextFormGroup
                    v-model="data.title"
                    name="title"
                    label="Title"
                    help-text="The title of the person."
                    :error="getError('title')"
                />

                <EmailFormGroup
                    v-model="data.email"
                    name="email"
                    label="Email"
                    help-text="The person's email."
                    :error="getError('email')"
                />

                <TextFormGroup
                    v-model="data.cell_phone"
                    name="cell_phone"
                    label="Cell Phone"
                    help-text="The person's cell phone number."
                    :error="getError('cell_phone')"
                />

                <TextFormGroup
                    v-model="data.work_phone"
                    name="work_phone"
                    label="Work Phone"
                    help-text="The person's work phone number."
                    :error="getError('work_phone')"
                />

                <RadioFormGroup
                    v-model="data.has_trigger_mails"
                    name="has_trigger_mails"
                    label="Has Trigger Mails"
                    help-text="A flag indicating if the person should receive trigger mails."
                    :error="getError('has_trigger_mails')"
                    :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
                />

                <SelectFormGroup
                    v-model="data.payment_condition_id"
                    name="payment_condition_id"
                    label="Payment Condition"
                    help-text="The payment condition that will be used for the person's invoices (optional)."
                    :error="getError('payment_condition_id')"
                    :options="paymentConditionOptions"
                    :placeholder="'Default (' + defaultPaymentCondition.name + ')'"
                    :nullable="true"
                />
              </div>
            </div>

            <AddressPanel
                v-model="data.address"
                :toggleable="true"
                :countries="{data: countries}"
                :errors="errors"
            />

            <hr class="panel-separator">

            <button type="submit" class="btn btn-black" style="margin-bottom: 22px;">
              <i class="fa fa-save"></i> Save
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import AddressPanel from '@/components/AddressPanel'
import EmailFormGroup from '@/vendor/forms/FormGroups/Horizontal/Email'
import Errors from '@/mixins/Errors'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    AddressPanel,
    EmailFormGroup,
    HelpText,
    LoadingContainer,
    RadioFormGroup,
    SelectFormGroup,
    TextFormGroup
  },

  mixins: [Errors],

  model: {
    prop: 'company',
    event: 'company-updated'
  },

  props: ['company'],

  data() {
    return {
      data: {
        address: null
      },

      paymentConditions: null,
      countries: null,
      loading: true
    }
  },

  computed: {
    paymentConditionOptions() {
      return this.paymentConditions.map(paymentCondition => {
        return {
          value: paymentCondition.id,
          label: paymentCondition.attributes.name
        }
      })
    },

    defaultPaymentCondition() {
      return this.paymentConditions.find(paymentCondition => paymentCondition.attributes.is_default)
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get("/api/v2/payment-conditions"),
        http.get("/api/v2/countries"),
      ]).then(responses=> {
        this.paymentConditions = responses[0].data.data

        this.countries = responses[1].data.data

        this.loading = false
      })
    },

    submit() {
      http.post('/api/v2/people', {...this.data,company_id: this.company.data.id})
          .then(response => {
            notify.success('The person was saved')

            this.$router.push('/people/' + response.data.data.id)
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
